export enum ShipmentStatusFilter {
  NotStarted = 'NotStarted',
  Started = 'Started',
  Assigned = 'Assigned',
  NotAssigned = 'NotAssigned',
  Finished = 'Finished'
}
